import { version } from '@superlayer/version';

export default version;
